/**
 * PublicShell — wraps unauthenticated routes with the Provide Cars Header
 * and Footer so login / signup / stock browse share consistent chrome.
 *
 * Pages own their own <main> content; PublicShell only adds the chrome
 * plus the page background.
 */
import type { ReactNode } from 'react';
import { Header } from '../chrome/Header';
import { Footer } from '../chrome/Footer';

interface PublicShellProps {
  children: ReactNode;
  /** When true, removes default vertical padding so pages with full-bleed
   *  hero sections (stock list) can manage their own spacing. */
  flush?: boolean;
}

export function PublicShell({ children, flush }: PublicShellProps): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main id="main-content" tabIndex={-1} className={`flex-1 ${flush ? '' : 'py-12 lg:py-16'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
